import React, { FC } from 'react';
import { Table, TableBody, TableContainer, TableHead, TableRow, TableCell, TableSortLabel } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BarcodeMappingRow from './BarcodeMappingRow';
import { BarcodeMappingDto } from '../../../app/services/api/orderManagementClient';    

type Props = {
  mappings: BarcodeMappingDto[];
  order: 'asc' | 'desc';
  orderBy: string;
  handleSort: (column: string) => void;
  onEdit: (mapping: BarcodeMappingDto) => void;
  onDelete: (mapping: BarcodeMappingDto) => void;
  hasWritePermission?: boolean;
};
const BarcodeMappingTable: FC<Props> = ({ mappings, order, orderBy, handleSort, onEdit, onDelete, hasWritePermission }) => {
  const { t } = useTranslation('barcodeMapping');

  return (
    <TableContainer>
      <Table size="medium">
        <TableHead>
          <TableRow>
            <TableCell>
              <TableSortLabel
                active={orderBy === 'Barcode'}
                direction={orderBy === 'Barcode' ? order : 'asc'}
                onClick={() => handleSort('Barcode')}
              >
                {t('barcode')}
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === 'ItemNumber'}
                direction={orderBy === 'ItemNumber' ? order : 'asc'}
                onClick={() => handleSort('ItemNumber')}
              >
                {t('itemNumber')}
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === 'UOM'}
                direction={orderBy === 'UOM' ? order : 'asc'}
                onClick={() => handleSort('UOM')}
              >
                {t('uom')}
              </TableSortLabel>
            </TableCell>
            <TableCell>
              <TableSortLabel
                active={orderBy === 'Name'}
                direction={orderBy === 'Name' ? order : 'asc'}
                onClick={() => handleSort('Name')}
              >
                {t('name')}
              </TableSortLabel>
            </TableCell>
            {hasWritePermission && <TableCell align="center">{t('delete')}</TableCell>}
            {hasWritePermission && <TableCell align="center">{t('edit')}</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {mappings.map((mapping) => (
            <BarcodeMappingRow
              key={mapping.Id}
              mapping={mapping}
              onEdit={() => onEdit(mapping)}
              onDelete={() => onDelete(mapping)}
              hasWritePermission={hasWritePermission}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BarcodeMappingTable;
